// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Download from './pages/Download';
import Blinks from './pages/Blinks';
import Docs from './pages/Docs';
import Contact from './pages/Contact';
import License from './pages/License';
import DonationSuccess from './pages/DonationSuccess';
import NotFound from './pages/NotFound';
import './App.css';
import ReactGA from 'react-ga4';

ReactGA.initialize("G-NNNR7YZ2RS");

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();

  // Google Analytics: Track page views on route change. (i am not sure if is already done automatically so this may not be needed)
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: document.title,
    });
  }, [location]);

  // Check if the current route is `/donation-success`
  const isDonationSuccessPage = location.pathname === '/donation-success';

  return (
    <div className='app-container'>
      {!isDonationSuccessPage && <Navbar />}
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blinks" element={<Blinks />} />
          <Route path="/download" element={<Download />} />
          <Route path="/docs/*" element={<Docs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<License />} />
          <Route path="/donation-success" element={<DonationSuccess />} />
          <Route path="*" element={<NotFound />} /> 
        </Routes>
      </div>
      {!isDonationSuccessPage && <Footer />}
    </div>
  );
}

export default App;
